import { useGlobal } from '@/utils/useGlobal';

export const useUsCaConfig = (locale: string) => {
    const { useLang } = useGlobal();
    const { t } = useLang('vanliferoadtrips');

    const cards = [
        {
            img: '',
            power: t('secH_card5_power'),
            title: t('secH_card5_title'),
            with: t('secH_card5_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/45w-portable-solar-panel?variant=41731341353033',
                    ca: 'https://ca.ecoflow.com/products/45w-portable-solar-panel?variant=52438137438579',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7264162676809',
                    ca: '8292312449178',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41731341353033',
                    ca: '52438137438579',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card5_desc1'), t('secH_card5_desc2'), t('secH_card5_desc3')],
        },
        {
            img: '/responsive/picture/common-products/110w.png',
            power: t('secH_card1_power'),
            title: t('secH_card1_title'),
            with: t('secH_card1_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/110w-portable-solar-panel?variant=39998109941833',
                    ca: 'https://ca.ecoflow.com/products/110w-portable-solar-panel?variant=43725961199770',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '4318647222345',
                    ca: '5511642644634',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998109941833',
                    ca: '43725961199770',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card1_desc1'), t('secH_card1_desc2'), t('secH_card1_desc3')],
        },
        {
            img: '/responsive/picture/common-products/160w.png',
            power: t('secH_card2_power'),
            title: t('secH_card2_title'),
            with: t('secH_card2_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/nextgen-160w-portable-solar-panel?variant=41682906218569',
                    ca: 'https://ca.ecoflow.com/products/nextgen-160w-portable-solar-panel?variant=52162328330611',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7003543044169',
                    ca: '8066687074458',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41682906218569',
                    ca: '52162328330611',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card2_desc1'), t('secH_card2_desc2'), t('secH_card2_desc3')],
        },
        {
            img: '/responsive/picture/common-products/220w_bifacial.png',
            power: t('secH_card3_power'),
            title: t('secH_card3_title'),
            with: t('secH_card3_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/nextgen-220w-bifacial-portable-solar-panel?variant=41670394576969',
                    ca: 'https://ca.ecoflow.com/products/220w-bifacial-portable-solar-panel?variant=43874721824922',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7003545108553',
                    ca: '7296662896794',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41670394576969',
                    ca: '43874721824922',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card3_desc1'), t('secH_card3_desc2'), t('secH_card3_desc3')],
        },
    ];
    const eu_cards: any = [
        {
            img: '/responsive/picture/common-products/400w.png',
            power: t('secH_card1_power'),
            title: t('secH_card1_title'),
            with: t('secH_card1_with'),
            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/400w-portable-solar-panel',
                    fr: 'https://fr.ecoflow.com/products/400w-portable-solar-panel',
                    eu: 'https://eu.ecoflow.com/products/400w-portable-solar-panel',
                    uk: 'https://uk.ecoflow.com/products/400w-portable-solar-panel',
                    it: 'https://it.ecoflow.com/products/400w-portable-solar-panel',
                    es: 'https://es.ecoflow.com/products/400w-portable-solar-panel',
                    nl: 'https://nl.ecoflow.com/products/400w-portable-solar-panel',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '15536875929981',
                    fr: '10084432576859',
                    eu: '10265047433559',
                    uk: '10123990729043',
                    it: '14963038814584',
                    es: '10084460560731',
                    nl: '9935698034964',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '56938043769213',
                    fr: '51330297998683',
                    eu: '51736552538855',
                    uk: '51828861469011',
                    it: '55270023627128',
                    es: '51300335288667',
                    nl: '51194372948244',
                };
                return localMap[locale] || localMap.eu;
            })(),

            descArr: [t('secH_card1_desc1'), t('secH_card1_desc2'), t('secH_card1_desc3')],
        },
        {
            img: '/responsive/picture/common-products/220W_portable_new.png',
            power: t('secH_card2_power'),
            title: t('secH_card2_title'),
            with: t('secH_card2_with'),
            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    fr: 'https://fr.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    eu: 'https://eu.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    uk: 'https://uk.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    it: 'https://it.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    es: 'https://es.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    nl: 'https://nl.ecoflow.com/products/nextgen-220w-bifacial-portable-solar-panel?variant=51427570286868',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '15321895600509',
                    fr: '9976213274971',
                    eu: '10107077493079',
                    uk: '9966309441875',
                    it: '14940806021496',
                    es: '9976244633947',
                    nl: '9935714386196',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '56293274190205',
                    fr: '50883301867867',
                    eu: '52180835959127',
                    uk: '52900139499859',
                    it: '55188408238456',
                    es: '50883390636379',
                    nl: '51427570286868',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secH_card2_desc1'), t('secH_card2_desc2'), t('secH_card2_desc3')],
        },
        {
            img: '/responsive/picture/common-products/160W_portable_new.png',
            power: t('secH_card3_power'),
            title: t('secH_card3_title'),
            with: t('secH_card3_with'),
            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/160w-portable-solar-panel',
                    fr: 'https://fr.ecoflow.com/products/160w-portable-solar-panel',
                    eu: 'https://eu.ecoflow.com/products/160w-portable-solar-panel',
                    uk: 'https://uk.ecoflow.com/products/160w-portable-solar-panel',
                    it: 'https://it.ecoflow.com/products/160w-portable-solar-panel',
                    es: 'https://es.ecoflow.com/products/160w-portable-solar-panel',
                    nl: 'https://nl.ecoflow.com/products/160w-portable-solar-panel',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '15321906676093',
                    fr: '9966244135259',
                    eu: '10106925056343',
                    uk: '9947421114707',
                    it: '14940805202296',
                    es: '9976249975131',
                    nl: '9935714353428',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '56293334679933',
                    fr: '50834554093915',
                    eu: '52608898203991',
                    uk: '52277093892435',
                    it: '55188402078072',
                    es: '50883397845339',
                    nl: '51427564355860',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secH_card3_desc1'), t('secH_card3_desc2'), t('secH_card3_desc3')],
        },
        {
            img: `/responsive/picture/common-products/110w.png`,
            power: t('secH_card4_power'),
            title: t('secH_card4_title'),
            with: t('secH_card4_with'),
            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/110w-portable-solar-panel',
                    fr: 'https://fr.ecoflow.com/products/110w-portable-solar-panel',
                    eu: 'https://eu.ecoflow.com/products/110w-portable-solar-panel',
                    uk: 'https://uk.ecoflow.com/products/110w-portable-solar-panel',
                    it: 'https://it.ecoflow.com/products/110w-portable-solar-panel',
                    es: 'https://es.ecoflow.com/products/110w-portable-solar-panel',
                    nl: 'https://nl.ecoflow.com/products/110w-portable-solar-panel',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '15711105941885',
                    fr: '10242120745307',
                    eu: '10431164711255',
                    uk: '10305317667155',
                    it: '14989722648952',
                    es: '10234409877851',
                    nl: '9935696822548',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '57526848946557',
                    fr: '51865825870171',
                    eu: '52266397565271',
                    uk: '52554238132563',
                    it: '55377721327992',
                    es: '51834443268443',
                    nl: '51194369933588',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secH_card4_desc1'), t('secH_card4_desc2'), t('secH_card4_desc3')],
        },
    ];

    return {
        cards,
        eu_cards,
    };
};
